import React from 'react'
import { Button } from '@mui/material'
import { csvUploadText, csvTasks } from './CSVUpload.config'
import { CSVUploadDialog } from './CSVUploadDialog'
import { useCSVUpload } from './CSVUpload.hooks'
import type {
  CSVColumnResponse,
  CSVUploadProps,
  CSVUploadSummary,
} from './CSVUpload.types'

export { csvTasks }
export type { CSVTask } from './CSVUpload.config'
export type { CSVColumnResponse, CSVUploadProps, CSVUploadSummary }

/**
 * Shared CSV upload component for CSV task endpoints.
 * @param initialTask - Optional initial selected CSV task
 * @param schoolID - Optional SchoolID option for createUser uploads
 * @param disabled - Disables interaction
 */
export function CSVUpload({
  initialTask,
  schoolID,
  disabled = false,
}: CSVUploadProps) {
  const {
    isDialogOpen,
    selectedTask,
    isLoadingColumns,
    isUploading,
    addRoles,
    fileName,
    errorMessage,
    summary,
    inputId,
    tableHeaders,
    openDialog,
    closeDialog,
    onTaskChange,
    onAddRolesChange,
    onFileChange,
    onDownloadTemplate,
  } = useCSVUpload({
    initialTask,
    schoolID,
  })

  const disabledState = disabled || isLoadingColumns || isUploading
  const uploadDisabledState = disabledState || selectedTask === ''

  return (
    <>
      <Button
        variant="contained"
        disabled={disabled}
        onClick={openDialog}
        data-testid="csv-task-dialog-open-button"
      >
        {csvUploadText.openButtonLabel}
      </Button>
      <CSVUploadDialog
        open={isDialogOpen}
        onClose={closeDialog}
        selectedTask={selectedTask}
        onTaskChange={onTaskChange}
        addRoles={addRoles}
        onAddRolesChange={onAddRolesChange}
        tableHeaders={tableHeaders}
        fileName={fileName}
        errorMessage={errorMessage}
        summary={summary}
        isLoadingColumns={isLoadingColumns}
        isUploading={isUploading}
        disabledState={disabledState}
        uploadDisabledState={uploadDisabledState}
        inputId={inputId}
        onFileChange={onFileChange}
        onDownloadTemplate={onDownloadTemplate}
      />
    </>
  )
}
